export const PROCESS_SIGINT = 'SIGINT';

export const PROCESS_EXIT = 'exit';

export const PROCESS_MESSAGE = 'message';

export const FORK_MESSAGE = PROCESS_MESSAGE;

export const FORK_ONLINE = 'online';

export const FORK_DISCONNECT = 'disconnect';

export const FORK_EXEC = 'exec';

export const FORK_DONE = 'done';
